import { ActionTypes } from './constants'
import type { ToolsProjectActions, ToolsProjectState } from './types'

const init: ToolsProjectState = {
  activeMode: null,
  activeLine: {},
}

const tools = (state = init, action: ToolsProjectActions): ToolsProjectState => {
  switch (action.type) {
    //

    case ActionTypes.SET_ACTIVE_MODE: {
      return {
        ...state,
        activeMode: action.payload.mode,
      }
    }

    case ActionTypes.SET_ACTIVE_LINE: {
      return {
        ...state,
        activeLine: action.payload.activeLine,
      }
    }

    default:
      return state
  }
}

export default tools
